import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Text } from '../Typography';
export var StyledLabel = styled(Text)(_templateObject(), function () {
  return "\n        width: 10%;\n        max-width: 10%;\n        overflow: visible;\n    ";
});
export var StyledBar = styled.div(_templateObject2(), function (props) {
  return "\n        position: relative;\n        margin-left: ".concat(props.theme.components.progress.marginLeft, ";\n        border-radius: 8px;\n        background-color: ").concat(props.theme.components.progress.barColor, ";\n        height: ").concat(props.theme.components.progress.barHeight, ";\n        width: 90%;\n\n        &:after {\n            transition: ").concat(props.theme.components.progress.transition, ";\n            content: '';\n            display: block;\n            border-radius: 8px;\n            height: 100%;\n            width: ").concat(props.value * 100, "%;\n            background-color: ").concat(props.theme.components.progress.colors[props.color] || props.color, ";\n        }\n    ");
});
export var StyledProgress = styled.div(_templateObject3(), function (props) {
  return "\n        font-family: \"Montserrat\";\n        display: flex;\n        align-items: center;\n        width: ".concat(props.width, ";\n        max-width: 100%;\n    ");
});